export const SET_LIST_PROJECT = 'SET_LIST_PROJECT'
export const RESET_LIST_PROJECT = 'RESET_LIST_PROJECT'
export const SET_LIST_SERVICE_CHARGE = 'SET_LIST_SERVICE_CHARGE'
export const SET_LIST_DELIVERY_MODE = 'SET_LIST_DELIVERY_MODE'
export const SET_LIST_TRANSPORT_MODE = 'SET_LIST_TRANSPORT_MODE'
export const SET_LIST_TRANSPORT_TYPE = 'SET_LIST_TRANSPORT_TYPE'
export const SET_LIST_UOM = 'SET_LIST_UOM'
export const SET_LIST_WAREHOUSE = 'SET_LIST_WAREHOUSE'
export const SET_LIST_PROJECT_SERVICE_CHARGE = 'SET_LIST_PROJECT_SERVICE_CHARGE'
export const SET_LIST_SKU = 'SET_LIST_SKU'
export const SET_LIST_PIN = 'SET_LIST_PIN'
export const SET_LIST_REPORT = 'SET_LIST_REPORT'
export const SET_LIST_CUSTOMER = 'SET_LIST_CUSTOMER'
export const SET_LIST_PROJECT_MEMBER = 'SET_LIST_PROJECT_MEMBER'
export const SET_LIST_USER_NOT_REGISTERED_PM = 'SET_LIST_USER_NOT_REGISTERED_PM'
export const SET_DASHBOARD = 'SET_DASHBOARD'
export const SET_LIST_ACCOUNT_MANAGEMENT = 'SET_LIST_ACCOUNT_MANAGEMENT'
export const SET_DETAIL_DASHBOARD = 'SET_DETAIL_DASHBOARD'
export const RESET_DETAIL_DASHBOARD = 'RESET_DETAIL_DASHBOARD'
export const SET_LIST_WAREHOUSE_MEMBERSHIP = 'SET_LIST_WAREHOUSE_MEMBERSHIP'
export const SET_LIST_SUB_DISTRICT = 'SET_LIST_SUB_DISTRICT'
export const SET_LIST_MASTER_WAREHOUSE_TYPE = 'SET_LIST_MASTER_WAREHOUSE_TYPE'
export const SET_LIST_BULK_UPLOAD_SKU = 'SET_LIST_BULK_UPLOAD_SKU'
export const SET_LIST_BULK_UPLOAD_PIN = 'SET_LIST_BULK_UPLOAD_PIN'
export const SET_LIST_EVIDENCE_CHECKLIST = 'SET_LIST_EVIDENCE_CHECKLIST'
export const SET_LIST_EVIDENCE_CHECKLIST_PROJECT = 'SET_LIST_EVIDENCE_CHECKLIST_PROJECT'
export const SET_MENU = 'SET_MENU'
export const SET_ACTIVE_MENU = 'SET_ACTIVE_MENU'
export const SET_LIST_MASTER_ASSET_TRUCK = 'SET_LIST_MASTER_ASSET_TRUCK'
export const SET_LIST_MASTER_PLATE_CODE = 'SET_LIST_MASTER_PLATE_CODE'
export const SET_LIST_MRS = 'SET_LIST_MRS'
export const RESET_ACTIVE_MENU = 'RESET_ACTIVE_MENU'
export const SET_LIST_MRS_DETAIL = 'SET_LIST_MRS_DETAIL'
export const SET_LIST_MRS_DETAIL_BULK_UPLOAD = 'SET_LIST_MRS_DETAIL_BULK_UPLOAD'
export const SET_LIST_TEMPLATE_SETTING = 'SET_LIST_TEMPLATE_SETTING'
export const SET_LIST_INV_MAIL_NOTIF = 'SET_LIST_INV_MAIL_NOTIF'
export const SET_PROJECT_ID = 'SET_PROJECT_ID'
export const SET_INFO = 'SET_INFO'
